import algorandLogo from '../assets/icons/algorandLogo.png'
import rippleLogo from '../assets/icons/rippleLogo.png'


export const ALGORAND = 'ALGORAND';
export const RIPPLE = 'RIPPLE';
export const ALGO = 'algo';
export const XRP = 'xrp';
export const ALGORAND_TEST_NET = 'ALGORAND_TEST_NET';
export const ALGORAND_MAIN_NET = 'ALGORAND_MAIN_NET';

export const networkDataToReturn = { 
    algorand(state) {
        return state.algorand.activeWallet
    },
    ripple(state) {
        return state.ripple.activeWallet
    }
}

export const coinToReturn = {
    algorand: 'algo',
    ripple: 'xrp'
}

export const availableNetworks = [
    { name: 'ALGORAND MAINNET', image: algorandLogo, id: 'algorand_mainnet' },
    { name: 'ALGORAND TESTNET', image: algorandLogo, id: 'algorand_testnet' },
    { name: 'XRPL TESTNET', image: rippleLogo, id: 'xrp_testnet'},
    { name: 'XRPL MAINNET', image: rippleLogo, id: 'xrp_mainnet' },
]
